<template>
  <v-navigation-drawer
    v-model="showDrawer"
    app
    class="nav-drawer"
    width="100%"
    temporary
    @input="onDrawerChange"
  >
    <template v-slot:prepend>
      <v-list-item class="background-color--primary">
        <v-list-item-title class="primary-font-color">
          {{ partnerGroupDetails.PartnerGroupDisplayName }}
        </v-list-item-title>
        <v-list-item-icon>
          <v-btn color="white" @click="closeDrawer" fab x-small elevation="0">
            <v-icon>close</v-icon>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
    </template>

    <v-list nav dense>
      <!-- account -->
      <v-list-item v-if="userIsLoggedIn" @click="onAccountBtnClick">
        <v-list-item-avatar>
          <v-img v-if="user.picture !== ''" :src="user.picture" />
          <v-icon v-else size="30">mdi-account-circle-outline</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ user.firstName }} {{ user.lastName }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="userIsLoggedIn" />

      <!-- translations -->
      <HeaderTranslations :isMobile="true" />
      <v-divider />

      <!-- Product categories -->
      <HeaderCategoriesMobile @close-menu="closeDrawer" />

      <!-- Themes -->
      <HeaderThemesMobile @close-menu="closeDrawer" />

      <!-- About us -->
      <!-- <v-list-item @click="onAboutUsClick">
        <v-list-item-content>
          <v-list-item-subtitle>
            {{ $translate('ABOUTUS') }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderThemesMobile from '@/components/generalComponents/header/HeaderThemesMobile';
import HeaderCategoriesMobile from '@/components/generalComponents/header/HeaderCategoriesMobile';
import HeaderTranslations from '@/components/generalComponents/header/HeaderTranslations.vue';

export default {
  name: 'NavigationDrawer',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeaderTranslations,
    HeaderThemesMobile,
    HeaderCategoriesMobile,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    userIsLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
  },
  data() {
    return {
      showDrawer: this.value,
    };
  },
  watch: {
    value() {
      this.showDrawer = this.value;
    },
  },
  methods: {
    closeDrawer() {
      this.showDrawer = false;
      this.onDrawerChange();
    },
    onDrawerChange() {
      this.$emit('input', this.showDrawer);
    },
    onAccountBtnClick() {
      if (this.userIsLoggedIn) {
        // User logged in, navigate to account page
        this.$router.push({
          name: 'UserSettings',
          params: { userSettings: true },
        });
      } else {
        // User is not logged in
        window.EventBus.fire('triggerOpenAccountFromMenu', {
          toggle: true,
          component: 'Login',
        });
      }
    },
    // onAboutUsClick() {
    //   this.$router.push({ name: 'AboutUs' });
    //   this.closeDrawer();
    // },
  },
};
</script>

<style lang="scss" scoped>
.nav-drawer {
  max-width: 500px;
}
</style>
